import React, { useRef } from 'react';
import { withDataConverter } from '@beef/react';
import { compose, withReduxStore } from '@beef/redux';
import classNames from 'classnames/bind';
import { withSentryHOC } from '@fttb/common/components';
import { AboutConnectionBlock } from "./blocks/AboutConnectionBlock";
import { HomeTariffsBannerBlock } from "./blocks/HomeTariffsBannerBlock";
import { ImageCardsBlock } from "./blocks/ImageCardsBlock";
import { ActionBarWithBackCall } from "./components/ActionBarWithBackCall";
import { FTTBPageLayout } from "./_PageLayout";
import { AdditionalInfoBlock, AdditionalServicesBlock, AddressVerificationBlock, ArticlesBlock, BannerBlock, CheckAddressBlock, DevicesBlock, FaqBlock, HeadingBlock, InfoCardsBlock, LeavePhoneBlock, NewsBlock, QuizBlock, TariffsBlock } from "./blocks";
import { FTTBFloatingPhoneWidget } from "./components/FloatingPhoneWidget";
import { FTTBOrderTariffFormPopup } from "./components/OrderTariffFormPopup";
import { Payment } from "./components/Payment";
import { SortController } from "./components/SortController";
import { LeaveYourPhonePopup } from "./containers";
import { convertFTTB2022CatalogPageData } from "./dataConverter";
import { initializeStore } from "./store";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * FTTB Catalog Redesign Page
 * See Mocks: '/packages/app/server/routes/stubs/pages/catalogPage/data.json'
 */
var FTTBCatalogPage = function FTTBCatalogPage() {
  var containerRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "pages-CatalogPage"
  }, /*#__PURE__*/React.createElement(HeadingBlock, {
    className: cx('heading')
  }), /*#__PURE__*/React.createElement(FTTBPageLayout, null, /*#__PURE__*/React.createElement(SortController, {
    className: cx('mainContainer'),
    containerRef: containerRef,
    "data-t-id": "pages-CatalogPage"
  }, /*#__PURE__*/React.createElement(InfoCardsBlock, {
    className: cx('info_cards'),
    "data-t-id": "pages-CatalogPage"
  }), /*#__PURE__*/React.createElement(CheckAddressBlock, {
    className: cx('checkAddress')
  }), /*#__PURE__*/React.createElement(TariffsBlock, {
    className: cx('tariffs'),
    containerRef: containerRef
  }), /*#__PURE__*/React.createElement(HomeTariffsBannerBlock, {
    className: cx('homeTariffs')
  }), /*#__PURE__*/React.createElement(ImageCardsBlock, {
    className: cx('advantages')
  }), /*#__PURE__*/React.createElement(AddressVerificationBlock, {
    className: cx('cards')
  }), /*#__PURE__*/React.createElement(BannerBlock, null), /*#__PURE__*/React.createElement(AboutConnectionBlock, {
    className: cx('cards')
  }), /*#__PURE__*/React.createElement(DevicesBlock, {
    className: cx('device')
  }), /*#__PURE__*/React.createElement(LeavePhoneBlock, {
    className: cx('leavePhone')
  }), /*#__PURE__*/React.createElement(AdditionalServicesBlock, {
    className: cx('cards')
  }), /*#__PURE__*/React.createElement(AdditionalInfoBlock, {
    className: cx('cards')
  }), /*#__PURE__*/React.createElement(QuizBlock, {
    className: cx('quiz')
  }), /*#__PURE__*/React.createElement(FaqBlock, {
    className: cx('faq')
  }), /*#__PURE__*/React.createElement(NewsBlock, {
    className: cx('news')
  }), /*#__PURE__*/React.createElement(ArticlesBlock, {
    className: cx('articles')
  }))), /*#__PURE__*/React.createElement(Payment, null), /*#__PURE__*/React.createElement(LeaveYourPhonePopup, null), /*#__PURE__*/React.createElement(FTTBOrderTariffFormPopup, null), /*#__PURE__*/React.createElement(FTTBFloatingPhoneWidget, null), /*#__PURE__*/React.createElement(ActionBarWithBackCall, null));
};
export var CatalogPage = compose(withDataConverter(convertFTTB2022CatalogPageData), withReduxStore(initializeStore), withSentryHOC)(FTTBCatalogPage);